export class NotEnoughFundsError extends Error {
    static get name() {
        return 'NotEnoughFunds';
    }
    constructor() {
        super('Not enough funds');
        this.name = 'NotEnoughFunds';
    }
}
